var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-resize-observer", { on: { resize: _vm.onResize } }, [
    _c(
      "div",
      {
        staticClass: "base-virtual-scroll-viewport-item",
        attrs: { "data-id": _vm.itemId, "data-index": _vm.realIndex },
      },
      [
        _c(
          "keep-alive",
          [
            _vm.isActivated
              ? _vm._t("default")
              : _c(
                  "div",
                  { style: { height: _vm.itemSize + "px" } },
                  [_vm._t("placeholder")],
                  2
                ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }